// extracted by mini-css-extract-plugin
export default {"DescriptionText":"DescriptionText_DescriptionText__7Mr2O","Light":"DescriptionText_Light__BjzIN","Dark":"DescriptionText_Dark__X2l7U"};